import List from '@mui/joy/List';
import { useSelector } from 'react-redux'
import IsobarCard from './IsobarCard';
import { useListFocus } from '../Context/ListFocus';
import { Virtuoso } from 'react-virtuoso';
import { useState, useCallback } from 'react';
import { extractIsobars } from '../Internal/helpers';


export default function IsobarSelector() {
    const intermediates = useSelector((state) => state.intermediateState);
    const graph = useSelector((state) => state.mainGraph);
    const finalStateData = useSelector((state) => state.finalState.finalStateData);
    const isobarViewFilter = useSelector((state) => state.isobarViewFilter);
    const symmetrizationEnabled = useSelector((state) => state.identicalParticles.symmetrizationEnabled);
    const [containerHeight, setContainerHeight] = useState(window.innerHeight - 80);
    const containerRef = useCallback((node) => {
        if (!node) return;
        const observer = new ResizeObserver(([entry]) => setContainerHeight(entry.contentRect.height));
        observer.observe(node);
    }, []);
    const { itemRefs, focusedKey, setKeyToIndex } = useListFocus();

    if (!intermediates.hasOwnProperty('isobars')) {
        return (
            <List>
            </List>
        );
    }


    const markedIsobars = {};
    if (graph.tuple) {
        extractIsobars(graph.tuple[0], markedIsobars);
        extractIsobars(graph.tuple[1], markedIsobars);
    }

    let isobarNames = []; // let so the view filter can narrow it below
    if (symmetrizationEnabled) {
        const groupedIsobars = {};
        for (const isobarName of Object.getOwnPropertyNames(intermediates.isobars)) {
            const isobar = intermediates.isobars[isobarName];
            const particleIsobarName = isobar.tuple.flat(Infinity).map(n => finalStateData[n] ? finalStateData[n].name : "").sort().join(" ");
            if (!groupedIsobars.hasOwnProperty(particleIsobarName)) {
                groupedIsobars[particleIsobarName] = isobarName;
            }
        }
        isobarNames = Object.values(groupedIsobars);
    } else {
        isobarNames = Object.getOwnPropertyNames(intermediates.isobars);
    }
    if (isobarViewFilter) {
        const allowedIsobars = {};
        extractIsobars(isobarViewFilter[0], allowedIsobars);
        extractIsobars(isobarViewFilter[1], allowedIsobars);
        isobarNames = isobarNames.filter(name => allowedIsobars.hasOwnProperty(name));
    }

    const keyToIndex = {};
    isobarNames.forEach((isobarName, index) => {
        keyToIndex[isobarName] = index;
    });

    const Row = ({ index }) => {
        const isobar = intermediates.isobars[isobarNames[index]];
        return (
            <IsobarCard isobar={isobar} variant={markedIsobars.hasOwnProperty(isobar.label) ? 'soft' : 'plain'} color={markedIsobars.hasOwnProperty(isobar.label) ? 'info' : 'neutral'} />
        );
    };

    return (
        <div ref={containerRef} style={{ height: '100%', width: '280px' }}>
            <Virtuoso
                ref={(el) => (itemRefs.current["ListRef"] = el)}
                totalCount={isobarNames.length}
                style={{ height: containerHeight, width: '280px' }}
                itemContent={(index) => <Row index={index} />}
            />
        </div>
    );
}